<div class="template video">
  <video
    class="template-video"
    #videoPlayer
    [src]="url"
    [poster]="thumbnailUrl"
    (error)="onError($event)">
  </video>
</div>
